@let eligible = eligibility();
<div
  class="eligibility-rule"
  [class.eligibility-rule--wrap]="$hasSubRules()"
  [class.success]="eligible.result"
  [class.warn]="!eligible.result">

  <app-badge
    [variant]="$badgeProps().variant"
    [icon]="$badgeProps().icon"
    size="lg"
    [title]="eligible.description"
    [class.eligibility-rule__badge-heading]="$hasSubRules()">
  </app-badge>

  @if (["and", "or"].includes(eligible.op) && $hasSubRules()) {
  <app-badge
    class="eligibility-rule__condition"
    [title]="eligible.op.toUpperCase()"
    [variant]="eligible.result ? 'success' : 'warning'">
  </app-badge>
  }

  @for (rule of eligible.args; track rule) {
  <eas-eligibility-view-rule [eligibility]="rule"></eas-eligibility-view-rule>
  }
</div>
